import React from 'react';
import SingleItemPage from "../SingleItemPage";

const CourseSessionInfo = (props) => {
    const { handleSubmit, values, setFieldValue } = props;
    const onActionClicked = () => {
        handleSubmit()
    }

    return <SingleItemPage values={values} setFieldValue={setFieldValue} handleSubmit={handleSubmit} params={{...values, onCtaClick: () => onActionClicked()}}/>;
};

export default CourseSessionInfo;